<template lang="pug">
.wrap
  page-title Add a new user

  el-row(:gutter="40")
    el-col(:lg="10")
      user-form(:user='newUser' ref='userForm')

      .actions
        el-button(type='primary' @click="submitForm") Create user

    el-col(:lg="14")
      h3.assign-seat-title Assign seats

      seats-assigner(v-model='newUser.appLicenseGroupIds' ref='seatsAsssigner')

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageTitle from "@/shared/components/layout/PageTitle";
import CrudMixin from "@/shared/mixins/Crud";
import UserForm from "@/shared/components/UserForm";
import SeatsAssigner from "@/shared/components/SeatsAssigner";

export default {
  mixins: [CrudMixin],
  components: { PageTitle, UserForm, SeatsAssigner },
  data() {
    return {
      newUser: {
        firstName: "",
        lastName: "",
        phoneNum: "",
        email: "",
        jobRole: "",
        isCompanyAdmin: false,
        isActive: true,
        appLicenseGroupIds: [],
        generatePassword: true
      }
    };
  },
  computed: {
    ...mapGetters({ activeCompany: "auth/activeCompany" })
  },
  methods: {
    ...mapActions({
      createUser: "users/createUser"
    }),
    submitForm() {
      this.$refs.userForm.validate(valid => {
        if (!valid) {
          this.$notify({
            title: "Error",
            message: "Please fix the validation errors",
            type: "error"
          });
          return;
        }
        const userData = { ...this.newUser, company: this.activeCompany.id };
        this.wrapApiAction(this.createUser)({ data: userData }).then(data => {
          this.$router.push({
            name: "companyAdmin:userEdit",
            params: { userId: data.companyUserId }
          });
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/mixins.scss";

.assign-seat-title {
  font-family: "gilroyextrabold";
  text-transform: uppercase;
  font-weight: normal;
  letter-spacing: 0.05em;
  font-size: 14px;
  color: #2c3e50;
  margin: 0 0 15px 0;
  @include MQ(LLG) {
    margin: 15px 0;
  }
}

.actions {
  margin-top: 20px;
}

.apps {
  display: flex;
}

.app {
  flex: 1;
  margin: 0 10px;
  border: 1px solid #ddd;
}

.app-header {
  background: #eee;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.app-name {
  font-weight: bold;
}

.app-remaining-seats {
  font-size: 30px;
  margin: 10px 0;
}

.app-groups {
  padding: 20px;
}

.app-group {
  margin: 10px 0;
}
</style>
